class WmdAvailability extends HTMLElement {
  constructor() {
    super();
    this.availability = [];
    this.postConfig = (data) => {
      return {
        method: 'POST',
        cache: 'no-cache',
        headers: {
          'Content-Type': 'application/json',
          'X-Requested-With': 'XMLHttpRequest'
        },
        redirect: 'follow',
        body: JSON.stringify(data)
      };
    };
  }

  connectedCallback() {
    this.available = false;
    this.market = window.wmd.market;
    this.productId = window.wmd.productId;
    if (this.productId !== '') {
      this.getAvailability();
      document.addEventListener('wmd-variant-change', (event) => {
        this.variantId = event.detail.variant.id.toString();
        this.changeAvailabilityNotice();
      });
    }
  }

  getAvailability() {
    const postData = this.postConfig({ market: this.market, productId: this.productId });
    const url = '/apps/wmd/api/getAvailability';
    fetch(url, postData).then(response => {
      if (response.ok) {
        return response.json();
      }
      else {
        throw new Error(`Response: ${response.status}`);
      }
    }).then(data => {
      this.availability = data;
      this.available = false;
      this.variantId = window.wmd.variantId;
      this.changeAvailabilityNotice();
      this.setElementVisibility();
    }).catch(error => {
      console.error(error.message);
    });
  };

  changeAvailabilityNotice() {
    const variant = this.availability.find(v => v.variant === this.variantId);
    const variantAvailability = variant.availability;
    const message = this.checkLocal(this.market, variantAvailability);
    if (message !== null) {
      document.getElementById('wmd-availability-notice').innerHTML = message;
    }
    this.setElementVisibility();
  };

  setElementVisibility(){
    if(this.available === true){
      document.querySelector('.wmd-klaviyo-wrapper').style.display = 'none';
      document.querySelector('.wmd-buy-buttons-wrapper').style.display = 'block';
      document.querySelector('variant-radios').style.display = 'block';
      document.querySelector('.product-form__quantity').style.display = 'block';
    }else{
      document.querySelector('.wmd-klaviyo-wrapper').style.display = 'block';
      document.querySelector('.wmd-buy-buttons-wrapper').style.display = 'none';
      document.querySelector('variant-radios').style.display = 'none';
      document.querySelector('.product-form__quantity').style.display = 'none';
    }
  }

  checkLocal(market, variantAvailability) {
    let local, extended, inTransit, inUkPackList, inEuPackList;
    let locations = {
      hedley: 'Hedley Warehouse',
      london: 'London Showroom',
      eu: 'EU Warehouse',
      ballack: 'Ballack',
      nepal: 'Nepal Lama',
      ukTransit: 'UK in Transit',
      euTransit: 'EU in Transit',
      ukPackList: 'UK Pack List',
      euPackList: 'EU Pack List'
    };
    let
      localLocation = null,
      ukTransitLocation = null,
      ukPackListLocation = null,
      euTransitLocation = null,
      euPackListLocation = null,
      extendedLocation = null
    ;

    switch (market) {
      case 'gb':
        localLocation = locations.hedley;
        ukTransitLocation = locations.ukTransit;
        ukPackListLocation = locations.ukPackList;
        euPackListLocation = locations.euPackList;
        extendedLocation = locations.ballack;
        break;
      case 'eu':
      case 'european-union':
        localLocation = locations.eu;
        euTransitLocation = locations.euTransit;
        euPackListLocation = locations.euPackList;
        ukPackListLocation = locations.ukPackList;
        extendedLocation = locations.ballack;
        break;
      case 'us':
      case 'united-states':
      case 'international':
        localLocation = locations.ballack;
        break;
    }

    // L1 is there a local product available - satisfies UK, EU and RoW?
    local = variantAvailability.find(warehouse => warehouse.location === localLocation);
    if (local?.available) {
      this.available = true;
      switch (market) {
        case 'gb':
          return window.wmd.ukAvailable;
        case 'eu':
        case 'european-union':
          return window.wmd.euAvailable;
        case 'us':
        case 'united-states':
        case 'international':
          return window.wmd.rowAvailable;
      }
    }
    // L1 UK - no local, so is this in the UK and is there one in transit or pack list?
    if (ukTransitLocation != null && ukPackListLocation != null && euPackListLocation != null) {
      inTransit = variantAvailability.find(warehouse => warehouse.location === ukTransitLocation);
      inUkPackList = variantAvailability.find(warehouse => warehouse.location === ukPackListLocation);
      inEuPackList = variantAvailability.find(warehouse => warehouse.location === euPackListLocation);
      if (inTransit?.available || inUkPackList?.available || inEuPackList?.available) {
        this.available = true;
        return window.wmd.ukAvailable;
      }
    }
    // L1 EU - no local, so is this in the EU and is there one in transit or pack list?
    if (euTransitLocation != null && ukPackListLocation != null && euPackListLocation != null) {
      inTransit = variantAvailability.find(warehouse => warehouse.location === euTransitLocation);
      inUkPackList = variantAvailability.find(warehouse => warehouse.location === ukPackListLocation);
      inEuPackList = variantAvailability.find(warehouse => warehouse.location === euPackListLocation);
      if (inTransit?.available || inUkPackList?.available || inEuPackList?.available) {
        this.available = true;
        return window.wmd.euAvailable;
      }
    }
    // L2 UK & EU - any in Ballack?
    if (extendedLocation != null) {
      extended = variantAvailability.find(warehouse => warehouse.location === extendedLocation);
      if (extended?.available) {
        switch (market) {
          case 'gb':
            this.available = true;
            return window.wmd.ukExtended;
          case 'eu':
          case 'european-union':
            this.available = true;
            return window.wmd.euExtended;
        }
      }
    }
    // no extended message for ROW
    // if no L1 or L2 availability then form will show with product being out of stock
    this.available = false;
    return window.wmd.soldOut;
  }

}

customElements.define('wmd-availability', WmdAvailability);


